
import Chart from 'chart.js';

export default function link(scope, element, attrs) {
	var ctx = element[0].getContext('2d');
	var myChart = new Chart(ctx, scope.config);
};



// WEBPACK FOOTER //
// ./src/directive/configurable-chart/configurable-chart.link.js